var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSocialIcon7(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 35,
    height: 35.094,
    viewBox: "0 0 35 35.094",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2364",
    "data-name": "Rectangle 2364",
    width: 35,
    height: 35.094,
    transform: "translate(-2 -2)",
    fill: "none",
    stroke: "#101b2d",
    strokeWidth: 0.5
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10400",
    "data-name": "Group 10400",
    transform: "translate(2 2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_10399",
    "data-name": "Group 10399",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_29374",
    "data-name": "Path 29374",
    d: "M12.72,31.024a3.2,3.2,0,0,1-2.312-.947L.952,20.621A3.244,3.244,0,0,1,0,18.17,3.657,3.657,0,0,1,1.12,15.748L15.74,1.115A3.571,3.571,0,0,1,18.382,0l9.236.232a3.215,3.215,0,0,1,3.144,3.2L31,12.658a3.656,3.656,0,0,1-1.115,2.654l-14.6,14.667a3.577,3.577,0,0,1-2.416,1.115Zm-.727-2.515a.993.993,0,0,0,.779.284,1.474,1.474,0,0,0,.929-.418L28.346,13.731a1.4,1.4,0,0,0,.424-1.005l-.238-9.234a.992.992,0,0,0-.993-.993l-9.23-.233a1.4,1.4,0,0,0-1.005.424L2.659,17.333a1.43,1.43,0,0,0-.424.923,1.019,1.019,0,0,0,.29.779Zm11.362-17.49a3.352,3.352,0,1,1,2.364-.981,3.351,3.351,0,0,1-2.364.981m0-4.461a1.117,1.117,0,1,0,.8,1.9,1.135,1.135,0,0,0,0-1.579,1.137,1.137,0,0,0-.8-.326",
    transform: "translate(0 0)",
    fill: "#161615",
    stroke: "#101b2d",
    strokeWidth: 0.5
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSocialIcon7);
export default __webpack_public_path__ + "static/media/social_icon7.936529c2fd255d62c206820d63b64ede.svg";
export { ForwardRef as ReactComponent };